import {
  Action, getModule, Module, VuexModule,
} from 'vuex-module-decorators';
import { validateOrReject } from 'class-validator';
import FileSaver from 'file-saver';
import { groupBy, mapValues, values } from 'lodash';
import repositoryFactory from '@/api/factory';

// eslint-disable-next-line
import store from '@/store';
import { DIRECT_DEBIT } from '@/constants/repository';
import DirectDebitRepository, { DirectDebitPaymentOrderDTO } from '@/api/direct-debit';
import { Transaction } from '@/models/Transaction';

const directDebitRepository = repositoryFactory
  .get<typeof DirectDebitRepository>(DIRECT_DEBIT);

@Module({
  name: DIRECT_DEBIT,
  namespaced: true,
  store,
  dynamic: true,
})
class DirectDebitModule extends VuexModule {
  @Action({ rawError: true })
  async generatePaymentOrder(transactions: Transaction[]) {
    try {
      await validateOrReject(transactions);
    } catch (e) {
      throw new Error('Invalid payment order');
    }

    const groups = values(mapValues(groupBy(transactions, 'creditor.id'), (ts: Array<Transaction>) => ({
      creditor: {
        name: ts[0].creditor.name,
        iban: ts[0].creditor.iban!,
        scheme: {
          id: ts[0].creditor.creditorSchemeId,
        },
      },
      transactions: ts.map((transaction) => ({
        debtor: {
          name: transaction.debtor.name,
          iban: transaction.debtor.iban!,
          mandate: {
            id: transaction.debtor.directDebitMandate!.mandateId,
            dateOfSignature: transaction.debtor.directDebitMandate!.dateOfSignature.toISOString(),
          },
        },
        amount: transaction.amount,
        reference: transaction.reference,
        description: transaction.description,
      })),
    })));

    const dto: DirectDebitPaymentOrderDTO = {
      groups,
    };

    const { data } = await directDebitRepository.post(dto);

    const blob = new Blob([data], { type: 'text/xml;charset=utf-8' });

    FileSaver.saveAs(blob);
  }
}

export default getModule(DirectDebitModule);
